import { ContentBuilder } from "@components/ContentBuilder";
import { Layout } from "@components/Layout";
import { GetServerSidePropsContext } from "next";
import { APITypes } from "utils/api.types";
import { fetchPageBySlug } from "utils/fetchingFunctions";
interface VacaturesProps {
  page: APITypes.Page;
}
export default function Vacatures({
  page
}: VacaturesProps) {
  return <Layout meta={page?.seo} data-sentry-element="Layout" data-sentry-component="Vacatures" data-sentry-source-file="index.tsx">
      {/*NavBar*/}
      {page.navigationBar && <ContentBuilder contentBlocks={page.navigationBar.content} slug={page.slug} localizations={page.localizations} />}

      <ContentBuilder contentBlocks={page.content} slug={page.slug} localizations={page.localizations} data-sentry-element="ContentBuilder" data-sentry-source-file="index.tsx" />
      {/*Contact*/}
      {page.contact && <ContentBuilder contentBlocks={page.contact.content} slug={page.slug} localizations={page.localizations} />}
      {/*Footer*/}
      {page.footer && <ContentBuilder contentBlocks={page.footer.content} slug={page.slug} localizations={page.localizations} />}
    </Layout>;
}
export async function getServerSideProps({
  res,
  locale,
  defaultLocale = "nl"
}: GetServerSidePropsContext) {
  try {
    const env = process.env.NEXT_PUBLIC_NODE_ENV || process.env.NODE_ENV;
    // Cache policy:
    // Requests are cached for two days (max-age & s-maxage).
    // Server can reuse an existing cache for a day after it is stale, provided the request is revalidated in the background (state-while-revalidate)
    if (env === "production" || env === "prod") {
      res.setHeader("Cache-Control", "public, max-age=172800 s-maxage=172800, stale-while-revalidate=86400");
    }
    const {
      data: pageRequestResult
    } = await fetchPageBySlug("vacatures", locale ?? defaultLocale);
    if (pageRequestResult && pageRequestResult.length > 0) {
      return {
        props: {
          page: pageRequestResult[0]
        }
      };
    }
    return {
      notFound: true
    };
  } catch (error) {
    return {
      notFound: true
    };
  }
}